export default "__VITE_ASSET__BRYVka_8__"